/**
 * Extract provider information from API response (matches clockout-components)
 */
export const extractProviderInfo = (data) => {
    const provider = data?.provider || (data?.atomic ? 'atomic' : 'pinwheel');

    if (provider === 'atomic' && data?.atomic) {
        return {
            provider: 'atomic',
            linkToken: data.atomic.token || data.atomic.publicToken,
            publicToken: data.atomic.token || data.atomic.publicToken,
            tokenId: data.atomic.id,
        };
    }

    if (data?.pinwheel) {
        return {
            provider: 'pinwheel',
            linkToken: data.pinwheel.token,
            publicToken: null,
            tokenId: data.pinwheel.id,
        };
    }

    return { provider: null, linkToken: null, publicToken: null, tokenId: null };
};
